/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneDensitySheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-DENSITY-001
 * PURPOSE: Photo Size + Fit/Fill. This is QaPhotoDisplayControls, not a new density system.
 */
import { MobileSheet, QaPhotoDisplayControls } from '@quotech/ui'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneDensitySheet({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Density" size="full">
      <div data-qa-phone-control={QA_PHONE_CONTROLS.density} className="flex min-h-[44px] items-center px-4 py-3">
        <QaPhotoDisplayControls />
      </div>
    </MobileSheet>
  )
}
